import React, { useState } from "react"
import { X } from "lucide-react"

const FIELDS = [
  { key: "hotel_name", label: "Отель" },
  { key: "star_name", label: "Звёзды" },
  { key: "region_name", label: "Регион" },
  { key: "resort_name", label: "Курорт" },
  { key: "date_entry", label: "Дата заезда (дд.мм.гггг)" },
  { key: "date_out", label: "Дата выезда (дд.мм.гггг)" },
  { key: "nights", label: "Ночей", type: "number" },
  { key: "food_name", label: "Питание" },
  { key: "type_room_name", label: "Тип номера" },
  { key: "price", label: "Базовая цена", type: "number" },
]

const EditTourModal = ({ open, onClose, onSubmit, tour }) => {
  const [form, setForm] = useState(() =>
    FIELDS.reduce((acc, f) => ({ ...acc, [f.key]: tour?.[f.key] ?? "" }), {})
  )

  if (!open) return null

  const handleChange = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }))

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-5 max-h-[85vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-[#1F2733]">Редактировать тур</h3>
          <button onClick={onClose} className="text-[#9AA5B4] hover:text-[#5A6779]">
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          {FIELDS.map((f) => (
            <label key={f.key} className="flex flex-col gap-1 text-xs text-[#5A6779]">
              {f.label}
              <input
                type={f.type || "text"}
                value={form[f.key]}
                onChange={handleChange(f.key)}
                className="border border-[#E7EAEF] rounded-lg px-3 py-2 text-sm"
              />
            </label>
          ))}

          <div className="flex justify-end gap-2 mt-2">
            <button type="button" onClick={onClose} className="text-sm text-[#5A6779] px-3 py-2">
              Отмена
            </button>
            <button type="submit" className="text-sm text-white bg-[#26303D] rounded-lg px-4 py-2">
              Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditTourModal
